<div>
    <label class="heading">Supplements(OWK)</label>

    <div class="col-8" style="padding-left:15px">
        <div>
            <mat-form-field class="col-4">
                <mat-label class="asterisk_input">Supplier Code</mat-label>
                <input matInput placeholder="Supplier Code" (blur)='validateInput()' [(ngModel)]="suppCd" maxlength="5">
                <mat-hint class="mat-error" *ngIf="enableError">{{suppErrorMsg}}</mat-hint>
            </mat-form-field>

        </div>

        <div>
            <mat-form-field class="col-4">
                <mat-label class="asterisk_input">Order Number</mat-label>
                <input matInput placeholder="Order Number" (blur)='validateInput()' [(ngModel)]="OrderNo"
                    maxlength="14">
                <mat-hint class="mat-error" *ngIf="enableError">{{OrdNoErrorMsg}}</mat-hint>
            </mat-form-field>

        </div>

        <div>
            <mat-form-field appearance="fill" class="col-4">
                <mat-label class="asterisk_input">Truck Type</mat-label>
                <mat-select [compareWith]="compareObjects" [(ngModel)]="truckSelected">
                    <mat-option *ngFor="let truck of truckTypes" [value]="truck">
                        {{ truck.trailerType }} <!-- Display trailerType instead of object -->
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>


        <div class="col-4 text-right mb-2">
            <button class="submit-btn" [disabled]="!enableSubmit" mat-raised-button (click)="view()">
                View
            </button>
        </div>
    </div>


</div>